<script>
import {defineComponent} from 'vue'
import ApiRequest from "@/core/api-request";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";

export default defineComponent({
  name: "ListMawbs",
  components: {VueBottomSheet},
  props: {
    selected_mawb: {
      required: false,
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      search: {
        timeout_id: null,
      },

      mawbs: [],
      index_page: 1,
      query_param: {
        mawb: '',
        size: 20,
        pagination: true,
        include: 'approvers,creator,category',
        type: 'i_created',
      },
      meta: {
        count: 0,
        total: 0,
        current_page: 1,
        total_pages: 1
      },
    }
  },
  methods: {
    fetch(concat = false) {
      let query_param = {...this.query_param};
      query_param.page = this.index_page;
      ApiRequest.get({
        uri: '/check-out/list-mawb',
        params: query_param,
        loadingE:'.list-mawb-container'
      }).then((result) => {
        if (concat) {
          let combinedArray = this.mawbs.concat(result.list_mawb);
          this.mawbs = [...new Set(combinedArray)];
        } else {
          this.mawbs = result.list_mawb;
        }

        this.meta = result.meta.pagination;
      });
    },
    onSearch() {
      if (this.search.timeout_id) {
        clearTimeout(this.search.timeout_id);
      }
      this.search.timeout_id = setTimeout(() => {
        this.fetch();
      }, 1000);
    },
    infinityScroll() {
      const scrollContainer = this.$refs.uncheck_container;
      const bottom = Math.round(scrollContainer.scrollHeight - scrollContainer.scrollTop) === scrollContainer.clientHeight;
      if (bottom) {
        if (this.meta.current_page < this.meta.total_pages) {
          this.index_page = this.meta.current_page + 1;
          this.fetch(true);
        }
      }

    },
    togleMawb(mawb) {
      let arr = [...this.selected_mawb];
      if (!this.selected_mawb.some(item => item.Mawb === mawb.Mawb)) {
        mawb.Pcs = mawb.Pcs_Remain;
        arr.push(mawb);
        this.$emit('update:selected_mawb', arr)
      } else {
        const index = arr.findIndex(item => item.Mawb === mawb.Mawb);
        if (index > -1) {
          arr.splice(index, 1);
        }
        this.$emit('update:selected_mawb', arr)
      }
    },


    show() {
      this.fetch();
      this.$refs.bottomSheet.open();
    },
    hide() {
      this.$refs.bottomSheet.close();
    }
  },

})
</script>

<template>
  <vue-bottom-sheet ref="bottomSheet">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Chọn Mawb check out</h5>
      <a type="button" class="btn-close my-auto" @click="hide()" aria-label="Close"><i
          class="fal fa-times text-secondary"></i></a>
    </div>
    <div class="modal-body border">
      <input type="text" class="form-control mb-2" v-model="query_param.mawb" @input="onSearch()"
             placeholder="Tìm MAWB - Các mawb cách nhau bới dấu cách">
      <div class="list-mawb-container" style="height: 50vh; overflow-y: auto" @scroll="infinityScroll" ref="uncheck_container">
        <table class="table table-head-fixed text-nowrap">
          <thead>
          <tr>
            <th></th>
            <th>Mawb</th>
            <th>Total</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="mawb in mawbs" :key="mawb.Mawb">
            <tr @click="togleMawb(mawb)">
              <td>
                <template v-if="!selected_mawb.some(item => item.Mawb === mawb.Mawb)">
                  <i class="fal fa-lg fa-circle text-orange"></i>
                </template>
                <template v-else>
                  <i class="fas fa-lg fa-check-circle text-orange"></i>
                </template>
              </td>
              <td><b class="mr-2 text-info">{{ mawb.Mawb }}</b></td>
              <td>{{ mawb.Pcs_Total }}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
  </vue-bottom-sheet>
</template>

<style scoped>
.table {
  vertical-align: inherit;

}

</style>